import React,{useState,useEffect} from 'react'
import axios from 'axios'
import {useAuth} from '../index'
import { IoReturnDownBackSharp } from 'react-icons/io5'
import { IoMdClose } from 'react-icons/io'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export function PurchasedHistoryPage() {
    const {auth2FA2, user2, logout} = useAuth()
    const [userInfo, setUserInfo] = useState(null)
    const [billingHistory, setBillingHistory] = useState('')
    const [nextPayment, setNextPayment] = useState('')
    const [showMore, setShowMore] = useState(false)
    const [msg, setMsg] = useState('')
    useEffect(() => {
      if(userInfo==null){
        const handleSubmit = async (e) => {
          const { data: res } = await axios.post(`${APIURL}/account-info/bill`, {token:window.localStorage.getItem('token')})
          if(res.msg==='user info ok'){
            console.log(res)
            // if(res.user.membership_details!=[]){
            //   const next_payment = new Date(res.user.next_payment * 1000).toISOString().slice(0, 10).replaceAll('-','.')
            //   setNextPayment(next_payment)
            // }
            setUserInfo(res.user)
            setBillingHistory(res.user['billing_history'])
          }
          else{
            setMsg(res.msg)
            setTimeout(() => {
              localStorage.removeItem('user')
              localStorage.removeItem('token')
              logout()
            }, 3000)
          }
        }
        setTimeout(handleSubmit, 1)
      }
    })
    const onClick2RefundOrder = async(x1) =>{
      const x2 = x1.split('_secret_')[0]
      const { data: res } = await axios.post(`${APIURL}/cancel-order`, {'email':userInfo.email,'order_id':x2})
    }
    return (
    <>
    <div className='text-left m-auto md:mt-8 w-full md:w-[580px] lg:w-[780px] text-[8px] md:text-base'>
    {/* Billing History */}
    {/* {userInfo==null?<div className='w-max m-auto mt-8 mb-8'><div className='secondary-loader'></div></div>: <div className='mt-4 mb-4 structure__main__caption'>Your are currently subscribing <b className='primary-color'>{userInfo.membership} membership</b>.<br/>Your next payment is {nextPayment}.</div>} */}
    <h2 className='mb-1 text-lg structure__main__subttl'>Purchased History</h2>
    <div className='mt-[1.2em] mb-[1px] leading-[1em] flex justify-between text-[10px] bitter font-bold border-b-[1px] border-gray-600'>
    <div className='w-1/5'>Date</div> 
    <div className='w-2/5'>Details</div>
    <div className='w-2/5'></div>
    </div>
    {userInfo==null?
    <div className='w-max m-auto mt-8 mb-8'><div className='secondary-loader'></div></div>
    :<>{billingHistory!=[]?<div>
      {billingHistory.map((x, i)=>(
      <>
      <>{showMore?<>{i<billingHistory.length-4?<div className='text-[9px] flex justify-between leading-[1.2em] mb-[8px]'>
      <div className='w-1/5 mt-auto mb-auto'>{(x.date).slice(0,10)}</div>
      <div className='w-2/5'>{x.details}<br/><div>{!x.purchased_items?'':x.purchased_items.map((y)=>(<div className='flex'>· {y.product_name} {y.price} <IoMdClose className='mt-[2px] text-[9px]'/>{y.unit}</div>))}</div>
      </div>
      <div className='w-1/5  mt-auto mb-auto text-right'>{x.price}</div>
      <div className='w-1/5'>{x.status=='cancelled'?'Cancelled':<>{new Date((x.date).slice(0,10).split('.')[0], (x.date).slice(0,10).split('.')[1] - 1,(x.date).slice(0,10).split('.')[2]).getTime()>new Date().getTime()-(86400000*30) && !x.order_id.includes('sub')?<div className='ml-auto mr-auto mt-[3px] border border-gray-800 w-fit mb-1 h-fit' onClick={()=>onClick2RefundOrder(x)}>Refund Order</div>:''}</>}</div>
      </div>:''}</>:''}</>
      <>{i>billingHistory.length-4?<div className='text-[9px] flex justify-between leading-[1.2em] mb-[8px]'>
      <div className='w-1/5 mt-auto mb-auto'>{(x.date).slice(0,10)}</div>
      <div className='w-2/5'>{x.details} {!x['purchased_items']?'':'no items'}
      <div className='text-[9px] leading-[1.2em]'>{!x['purchased_items']?'':x.purchased_items.map((y)=>(<div className='flex'>· {y.product_name} {y.price} <IoMdClose className='mt-[2px] text-[9px]'/>{y.unit}</div>))}</div>
      </div>
      <div className='w-1/5 mt-auto mb-auto text-right'>{x.price}</div>
      <div className='w-1/5'>{x.status=='cancelled'?'Cancelled':<>{new Date((x.date).slice(0,10).split('.')[0], (x.date).slice(0,10).split('.')[1] - 1,(x.date).slice(0,10).split('.')[2]).getTime()>new Date().getTime()-(86400000*30)&&!x.order_id.includes('sub')?<div className='ml-auto mr-auto mt-[3px] border border-gray-800 w-fit h-fit pl-[4px] pr-[4px] pt-[2px] pb-[2px] hover:bg-gray-200' onClick={()=>onClick2RefundOrder(x.order_id)}>Cancel Order</div>:''}</>}</div>
      </div>:''}</>
      </>
      ))}
      {billingHistory.length>4?<div className='text-right w-full text-xs'><button className='underline w-fit mb-1 h-fit text-[9px]' onClick={()=>setShowMore(!showMore)}>{showMore?'Show less..':'Show more..'}</button></div>:''}
    </div>:'No purchase records'}</>
    }
    <br/><br/><br/>
    </div>
    </>
    )
}
